import { CXoneAgentEvent } from '../agent/cxone-agent-event';
import { IndicatorActionType } from '../../enum/indicator-action-type';

/**
 * Model class for CXone Indicators
 */
export class CXoneIndicator extends CXoneAgentEvent {
  /**
   * @remarks - Type of Indicator - Agent / Contact
   */
  isContactIndicator!: boolean;
  /**
   * @remarks - Action of indicator
   */
  actionValue!: string;
  /**
   * @remarks - Type of indicator
   */
  actionType!: IndicatorActionType;
  /**
   * @remarks - path of indicator image
   */
  imageFile!: string;
  /**
   * @remarks - Unique identifier of indicator
   */
  indicatorName!: string;
  /**
   * @remarks - Unique identifier of sender contact id
   */
  contactId!: string;
  /**
   * @remarks - Tooltip of indicator
   */
  toolTip!: string;
  /**
   * @remarks -
   */
  isEnabled!: boolean;
  /**
   * @remarks - Callback method for custom form
   */
  customFormCallback?: (event: any) => void;

  /**
   * The constructor will take the data object and assign the values to the cxone indicators class properties
   * @param data - Data object received
   * @example -
   * ```
   * cxoneIndicator.parse(indicator);
   * ```
   */
  parse(data: { [key: string]: any }): void {
    this.isContactIndicator = data.ContactID ? true : false;
    this.iisHost = data.IISHost;
    this.vcHost = data.VCHost;
    this.actionValue = data.action || data.ActionUri;
    this.actionType = data.actionType || data.ActionType;
    this.imageFile = data.imageFile || data.ImageUri;
    this.indicatorName = data.indicatorName || data.Name;
    this.contactId = data.senderContactId || data.ContactID;
    this.toolTip = data.toolTip || data.ToolTip;
    this.isEnabled = data.enable || data.IndicatorState === 'On';
  }
}
